import { navyColor, blackLightColor, blackColor, grayLightColor } from '../global';

const CartViewerStyle = (theme) => ({
    spacingViewer: {
        margin: '0 0 20px 0',
    },
    customTable: {
        '& > table > tbody > tr': {
            '& > td:nth-child(4)': {
                textAlign: 'center',
            },
        },
    },
    selectProduct: {
        '& > div > div:before': {
            content: 'none',
        },

        '& > div > div:after': {
            content: 'none',
        },

        '& > div > div > select:focus': {
            backgroundColor: 'transparent',
        },

        '& > div > div > select': {
            padding: '0px',
            fontSize: '14px',
        },
    },
    disableSelect: {
        pointerEvents: 'none',

        '& > div > div:before': {
            content: 'none',
        },

        '& > div > div:after': {
            content: 'none',
        },

        '& > div > div > select:focus': {
            backgroundColor: 'transparent',
        },

        '& > div > div > select': {
            padding: '0px',
            fontSize: '14px',
            color: grayLightColor,
        },
        '& > div > div > svg': {
            color: grayLightColor,
        },
    },
    allTotalPrice: {
        padding: '20px',
        fontSize: '28px',
    },
    buttonBig: {
        fontSize: '24px !important',
        margin: '10px !important',
        whiteSpace: 'break-spaces',
        padding: '10px 40px !important',
    },
    spacingPrice: {
        margin: '0 0 20px 0',
        borderTop: `1px solid ${blackLightColor}`,
        paddingTop: '10px',
    },
    historyOrder: {
        paddingBottom: '20px',
        borderBottom: `1px solid ${blackLightColor}`,
    },
    spacingTitleHistory: {
        marginTop: '20px',
    },
    customTableOrder: {
        maxHeight: '411px',
    },
    room: {
        border: `1px solid ${blackColor}`,
        borderRadius: '13px',
        padding: '0 20px',
    },
    titleDetail: {
        paddingTop: '15px',
    },
    dialogOrder: {
        paddingTop: '6px',
        paddingBottom: '6px',
    },
    spacingTotalPrice: {
        borderTop: `1px solid ${blackLightColor}`,
        paddingTop: '10px',
    },
    infoOrder: {
        marginLeft: '35px',
        marginTop: '20px',
    },
    marginTopOrder: {
        marginTop: '20px',
        padding: 0,
    },
    noPadding: {
        padding: 0,
    },
    noPaddingOrder: {
        padding: '20px 0 0 0',
    },
    radioButton: {
        marginLeft: '120px',
        '& > span': {
            color: (props) => props?.customColor?.button_background_color?.common_button || props?.button_background_color?.common_button,
        },
        '& .Mui-checked': {
            color: (props) => props?.customColor?.button_background_color?.common_button || props?.button_background_color?.common_button,
        },
        '@media (max-width: 500px)': {
            marginLeft: 0,
            '& > span': {
                color: (props) => props?.customColor?.button_background_color?.common_button || props?.button_background_color?.common_button,
            },
            '& .Mui-checked': {
                color: (props) => props?.customColor?.button_background_color?.common_button || props?.button_background_color?.common_button,
            },
        },
    },
    colorIconRadio: {
        '& > span': {
            color: (props) => props?.customColor?.button_background_color?.common_button || props?.button_background_color?.common_button,
        },
        '& .Mui-checked': {
            color: (props) => props?.customColor?.button_background_color?.common_button || props?.button_background_color?.common_button,
        },
    },
    leftTitle: {
        textAlign: 'left',
        paddingRight: '46px',
    },
    rightInput: {
        marginBottom: '15px',
    },
    rightSelect: {
        marginBottom: '15px',
        display: 'flex',
        alignItems: 'center',
        '& > div': {
            width: '35%',
        },
    },
    rightSelectNoMargin: {
        width: '74%',
        display: 'flex',
        alignItems: 'center',
        '& > div': {
            width: '35%',
        },
    },
    titleMonth: {
        display: 'block',
        marginRight: '30px',
        marginLeft: '10px',
        color: (props) => props?.contents_text_color,
    },
    titleYear: {
        display: 'block',
        marginLeft: '10px',
        color: (props) => props?.contents_text_color,
    },
    paperInfoOrder: {
        paddingTop: '20px',
        border: `1px solid ${blackLightColor}`,
        borderRadius: '10px',
    },
    spacing: {
        padding: '15px 0',
    },
    rightInfoInput: {
        padding: '0',
    },
    buttonSmall: {
        fontSize: '24px !important',
        padding: '5px 20px !important',
        margin: '10px !important',
        borderRadius: '10px',
        whiteSpace: 'break-spaces',
    },
    spacingBottom: {
        paddingBottom: '15px',
    },
    invoiceNumber: {
        textAlign: 'end',
        paddingRight: '25px',
    },
    totalPrice: {
        paddingLeft: '25px',
    },
    colCenter: {
        textAlign: 'center',
    },
    colorTextInput: {
        '& input': {
            color: '#4b4b4b',
        },
        '& label.Mui-focused': {
            color: '#4b4b4b',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#4b4b4b',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: '#4b4b4b',
            },
        },
    },
});

export default CartViewerStyle;
